// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope } from 'react-icons/fa';
import SEO from './SEO';
import './Footer.css';
import './FooterIcons.css';

const Footer = () => {
  return (
    <>
      <SEO 
        title="Footer - Student Helper"
        description="Connect with us and access important links through our footer section."
        keywords="student helper footer, contact information, social media links, footer navigation"
      />
      <footer className="footer modern-footer">
        <div className="footer-content">
          <motion.div 
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h3>Student Helper</h3>
            <p>Your one-stop platform for academic success.</p>
          </motion.div>

          <motion.div 
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h3>Quick Links</h3>
            <div className="footer-links-grid">
              <div className="footer-links-column">
                <Link to="/">Home</Link>
                <Link to="/materials">Materials</Link>
                <Link to="/qa">Q&A</Link>
                <Link to="/contact">Contact</Link>
              </div>
              <div className="footer-links-column">
                <Link to="/peer-learning">Peer Learning</Link>
                <Link to="/expert-support">Expert Support</Link>
                <Link to="/exam-preparation">Exam Preparation</Link>
                <Link to="/career">Career</Link>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3>Follow Us</h3>
            <div className="social-links-wrapper">
              <div className="social-links">
                <a href="https://github.com/co-der11/student-helper" className="social-link">
                  <FaGithub />
                </a>
                <a href="https://linkedin.com/in/yourusername" className="social-link">
                  <FaLinkedin />
                </a>
                <a href="https://twitter.com/yemam011" className="social-link">
                  <FaTwitter />
                </a>
                <a href="mailto:your.yemam011@gmail.com" className="social-link">
                  <FaEnvelope />
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div 
          className="footer-bottom"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <p>&copy; {new Date().getFullYear()} Student Helper. All rights reserved.</p>
        </motion.div>
      </footer>
    </>
  );
};

export default Footer;
